import $ from 'jquery';

export default class Zoom {
  constructor(instance) {
    this.$el = $(instance.el);
    this.$zoomArea = $('.product-image-zoom', this.$el);
    this.events = [
      this.$zoomArea.on('mouseover.zoom', () => this.prepareZoom()),
      this.$zoomArea.on('mouseout.zoom', (event) => this.toggleZoom(event)),
      this.$zoomArea.on('mousemove.zoom', (event) => this.zoomImage(event)),
      $('.product-big-image', this.$el).on('prepare-zoom.zoom', this.prepareZoom()),
      this.$el.on('click.zoom', (event) => this.toggleZoom(event)),
    ];

    $('img', this.$el).one('rimg:load', () => this.prepareZoom());
  }

  prepareZoom() {
    const highResSrc = this.$el.find('img').attr('data-high-res');
    const newImage = new Image();

    this.$newImage = $(newImage);

    this.$newImage.on('load', () => {
      const imageWidth = newImage.width;
      const imageHeight = newImage.height;

      const photoAreaWidth = this.$el.width();
      const photoAreaHeight = this.$el.height();

      const ratios = [];
      ratios.push(imageWidth / photoAreaWidth);
      ratios.push(imageHeight / photoAreaHeight);

      const ratio = Math.max.apply(null, ratios);

      if ((ratio >= 1) && (imageWidth > photoAreaWidth) && (imageHeight > photoAreaHeight)) {
        this.$el.addClass('zoom-enabled');
        this.$zoomArea.css({ backgroundImage: `url('${highResSrc}')` });
      } else {
        this.$el.removeClass('zoom-enabled');
      }
    });

    return newImage.src = highResSrc;
  }

  toggleZoom(event) {
    if (!this.$el.hasClass('zoom-enabled')) { return; }

    if (event.type === 'mouseout') {
      this.$zoomArea.removeClass('active');
      this.$zoomArea.css({ backgroundPosition: '50% 50%' });
      return;
    }

    if (this.$zoomArea.hasClass('active')) {
      this.$zoomArea.removeClass('active');
    } else {
      this.$zoomArea.addClass('active');
    }

    this.zoomImage(event);
  }

  zoomImage(event) {
    const zoomWidth = this.$zoomArea.width();
    const zoomHeight = this.$zoomArea.height();

    const bigImageOffset = this.$el.offset();
    const bigImageX = Math.round(bigImageOffset.left);
    const bigImageY = Math.round(bigImageOffset.top);

    const mousePositionX = event.pageX - bigImageX;
    const mousePositionY = event.pageY - bigImageY;

    if (
      (mousePositionX < zoomWidth)
      && (mousePositionY < zoomHeight)
      && (mousePositionX > 0)
      && (mousePositionY > 0)
    ) {
      if (this.$zoomArea.hasClass('active')) {
        const ratioY = ((event.pageY - bigImageY) / zoomHeight) * 100;
        const ratioX = ((event.pageX - bigImageX) / zoomWidth) * 100;

        this.$zoomArea.css({ backgroundPosition: `${ratioX}% ${ratioY}%` });
      }
    }
  }

  prepareRemove() {
    this.$newImage.off('load');
    this.events.forEach($el => $el.off('.zoom'));
  }
}
